module.exports = __webpack_public_path__ + "h5/img/logo1.b08c0e5e.png";